import React from 'react';
import { FiPlus, FiX, FiUserPlus, FiStar } from 'react-icons/fi';

const FormTeam = ({
  formData,
  staffArray,
  selectedStaffId,
  setSelectedStaffId,
  selectedRole,
  setSelectedRole,
  selectedHours,
  setSelectedHours,
  selectedIsLead,
  setSelectedIsLead,
  onAddTeamMember,
  onRemoveTeamMember
}) => {
  return (
    <div className="bg-[var(--bg-primary)] p-6 rounded-xl shadow-[var(--shadow-sm)] border border-[var(--border-color)]">
      <h3 className="text-lg font-semibold text-[var(--text-primary)] mb-4 flex items-center gap-2">
        <FiUserPlus size={18} className="text-blue-500" />
        <span>Tim Pengerjaan</span>
        {formData.team && formData.team.length > 0 && (
          <span className="text-sm font-normal text-[var(--text-secondary)] ml-2">
            ({formData.team.length} orang)
          </span>
        )}
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-3 mb-3">
        <div>
          <label className="block text-sm text-[var(--text-secondary)] mb-1">
            Pilih Staff
          </label>
          <select
            value={selectedStaffId}
            onChange={(e) => setSelectedStaffId(e.target.value)}
            className="w-full px-3 py-2 border border-[var(--border-color)] rounded-lg bg-[var(--bg-primary)] text-[var(--text-primary)] focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">-- Pilih Staff --</option>
            {staffArray.map(member => (
              <option key={member.id} value={member.id}>
                {member.name} - {member.level || 'Staff'}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm text-[var(--text-secondary)] mb-1">
            Role / Posisi
          </label>
          <input
            type="text"
            value={selectedRole}
            onChange={(e) => setSelectedRole(e.target.value)}
            placeholder="Koordinator, Fabrikasi, dll"
            className="w-full px-3 py-2 border border-[var(--border-color)] rounded-lg bg-[var(--bg-primary)] text-[var(--text-primary)] focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div>
          <label className="block text-sm text-[var(--text-secondary)] mb-1">
            Estimasi Jam
          </label>
          <input
            type="number"
            min="1"
            value={selectedHours}
            onChange={(e) => setSelectedHours(parseInt(e.target.value) || 0)}
            className="w-full px-3 py-2 border border-[var(--border-color)] rounded-lg bg-[var(--bg-primary)] text-[var(--text-primary)] focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div className="flex items-end gap-2">
          <div className="flex-1">
            <label className="block text-sm text-[var(--text-secondary)] mb-1">
              <span className="flex items-center gap-1">
                <FiStar size={12} className="text-yellow-500" />
                Koordinator
              </span>
            </label>
            <select
              value={selectedIsLead ? 'true' : 'false'}
              onChange={(e) => setSelectedIsLead(e.target.value === 'true')}
              className="w-full px-3 py-2 border border-[var(--border-color)] rounded-lg bg-[var(--bg-primary)] text-[var(--text-primary)] focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="false">Tidak</option>
              <option value="true">Ya</option>
            </select>
          </div>
          <button
            type="button"
            onClick={onAddTeamMember}
            disabled={!selectedStaffId}
            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg disabled:opacity-50 flex items-center gap-2 h-[42px]"
          >
            <FiPlus size={16} />
            Tambah
          </button>
        </div>
      </div>

      {formData.team && formData.team.length > 0 ? (
        <div className="mt-3 border-t border-[var(--border-color)] pt-3">
          <div className="flex flex-wrap gap-2">
            {formData.team.map((member, index) => (
              <div
                key={index}
                className={`flex items-center gap-2 px-3 py-1.5 rounded-full text-sm border ${
                  member.isLead 
                    ? 'bg-yellow-50 border-yellow-300 text-yellow-800' 
                    : 'bg-blue-50 border-blue-200 text-blue-800'
                }`}
              >
                {member.isLead && <FiStar size={12} className="text-yellow-500" />}
                <span className="font-medium">{member.name}</span>
                <span className="text-[var(--text-secondary)] text-xs">
                  ({member.role || 'Anggota'} • {member.hours || 0} jam)
                </span>
                <button
                  type="button"
                  onClick={() => onRemoveTeamMember(index)}
                  className="text-red-500 hover:text-red-700 ml-1"
                >
                  <FiX size={14} />
                </button>
              </div>
            ))}
          </div>
          
          <div className="mt-2 text-xs text-[var(--text-secondary)]">
            Total estimasi jam: {formData.team.reduce((sum, m) => sum + (m.hours || 0), 0)} jam
          </div>
        </div>
      ) : (
        <p className="text-sm text-[var(--text-secondary)] mt-2">
          Belum ada tim. Tambahkan staff di atas.
        </p>
      )}
    </div>
  );
};

export default FormTeam;